import LegalHero from "@/pages/legal/components/LegalHero";
import LegalArticle from "@/pages/legal/components/LegalArticle";
import LegalContactCta from "@/pages/legal/components/LegalContactCta";
import { legalPages, medicalAdvertisingSections } from "@/mocks/legalPages";

export default function MedicalAdvertisingPage() {
  const meta = legalPages.medicalAdvertising;

  return (
    <>
      <LegalHero path={meta.path} en={meta.en} h1={meta.h1} lead={meta.lead} />

      <section className="bg-background-50 py-16 md:py-20 lg:py-24">
        <div className="u-container">
          <div className="mx-auto max-w-3xl">
            <LegalArticle sections={medicalAdvertisingSections} />
          </div>
        </div>
      </section>

      <LegalContactCta
        heading="美容医療の広告表示についてのご質問"
        note="ご不明な点がございましたら、お電話またはLINEよりお気軽にお問い合わせください。"
      />
    </>
  );
}